import { render, staticRenderFns } from "./BagType.vue?vue&type=template&id=40cc34e0&scoped=true&"
import script from "./BagType.vue?vue&type=script&lang=js&"
export * from "./BagType.vue?vue&type=script&lang=js&"
import style0 from "./BagType.vue?vue&type=style&index=0&id=40cc34e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cc34e0",
  null
  
)

component.options.__file = "BagType.vue"
export default component.exports